import ajax from "./ajax";

export function getPage(internalName) {
  return ajax(`/pages?PageSearch[url_slug]=${internalName}`);
}
